import MidiNode from '../../core/MidiNode';
import Effect from '../Effect';
class MidiEffect extends Effect {
    constructor() {
        super();
        this.inputNode = new MidiNode();
        this.outputNode = new MidiNode();
        this.inputNode.triggerAttack = this.triggerAttack.bind(this);
        this.inputNode.triggerRelease = this.triggerRelease.bind(this);
    }
    input() { return this.inputNode; }
    output() { return this.outputNode; }
}
export default MidiEffect;
//# sourceMappingURL=MidiEffect.js.map